import { AlertSettings, AlertType, FormType, IncidentSettings, PriorityType, SendAlertRequest, TextMessageChannel } from 'src/app/hickory-api';
import { DataGenerator } from './DataGenerator';
import { genericIncidentData } from './GenericIncidentData';
import { DEFAULT_COORDS } from 'src/app/shared/google-maps';

export class AlertSettingsData extends DataGenerator<AlertSettings> {
  static instance = new AlertSettingsData();

  protected createPredefined(): AlertSettings[] {
    return [
      {
        // Emergency Alert with Severity Assessment and Attachments
        id: 1,
        alertType: AlertType.Default,
        timeSent: new Date(1514836799000),
        location: {
          point: {
            lat: DEFAULT_COORDS.lat,
            lng: DEFAULT_COORDS.lng
          }
        },
        channels: {
          email: {
            send: false,
          },
          push: {
            send: true,
          },
          textMessage: {
            primary: false,
            secondary: false,
            deliveryMethod: TextMessageChannel.DeliveryMethodEnum.Smtp,
            send: false
          },
          voice: {
            send: false
          }
        },
        formType: FormType.Quick,
        message: {
          priority: PriorityType.Emergency,
          basic: {
            message: 'Attack on the Gnotty Gnome Tavern! To ensure the safety of yourself, ' +
                  'push customers and employees out of the way and get out!',
            subject: 'Tavern Attacked'
          },
          files: [
            {
              uri: 'https://baconmockup.com/470/300/',
              fileName: 'hiding.jpg',
              contentType: 'image/jpeg',
              length: 156023
            },
            {
              uri: 'https://baconmockup.com/470/300/',
              fileName: 'hiding.jpg',
              contentType: 'image/jpeg',
              length: 156023
            },
            {
              uri: 'https://baconmockup.com/300/470/',
              fileName: 'hiding.jpg',
              contentType: 'image/jpeg',
              length: 156023
            }
          ],
          incidentId: genericIncidentData.generated[0].id,
          incident: {
            id: 'dce4b6e6257c4f8eb7e0e3a407d85110',
            name: 'Incident 1',
            priority: PriorityType.Emergency,
            type: IncidentSettings.TypeEnum.Generic
          },
          severityAssessment: {
            comment: 'This is a test, do not be alarmed!',
            responses: [
              {
                questionId: 'id_hilton_assessment_questions_seriousillness',
                optionId: 'id_hilton_assessment_responses_yesno_yes',
              },
              {
                questionId: 'id_hilton_assessment_questions_propertydamage',
                optionId: 'id_hilton_assessment_responses_yesno_yes',
              },
              {
                questionId: 'id_hilton_assessment_questions_businessdisruption',
                optionId: 'id_hilton_assessment_responses_yesno_yes',
              },
              {
                questionId: 'id_hilton_assessment_questions_evacuation',
                optionId: 'id_hilton_assessment_responses_yesno_yes',
              },
              {
                questionId: 'id_hilton_assessment_questions_mediainterest',
                optionId: 'id_hilton_assessment_responses_yesno_yes',
              }
            ]
          }
        },
        schedule: {
          scheduled: false
        },
        recipients: {
          groupIds: [1002, 1003, 1004], // Default groupIds imply MAGs (Mandatory Groups)
          mandatoryGroupIds: [],
          contactIds: [1001, 1002, 1003]
        },
        sender: {
          displayName: 'Taylor Grohs',
          email: 'basketballking@earthlink.com',
          externalId: 'RnD007',
          asset: {
            name: 'Boise Alert Sense'
          }
        }
      }, {
        // Emergency Poll
        id: 2,
        alertType: AlertType.Poll,
        timeSent: new Date(1514923199000),
        location: {
          point: {
            lat: DEFAULT_COORDS.lat + 1,
            lng: DEFAULT_COORDS.lng + 1
          }
        },
        channels: {
          email: {
            send: false,
          },
          push: {
            send: true,
          },
          textMessage: {
            primary: false,
            secondary: false,
            deliveryMethod: TextMessageChannel.DeliveryMethodEnum.Smtp,
            send: false
          },
          voice: {
            send: false
          }
        },
        formType: FormType.Quick,
        message: {
          priority: PriorityType.Emergency,
          basic: {
            message: 'Attack on the Gnotty Gnome Tavern! To ensure the safety of yourself, ' +
                  'push customers and employees out of the way and get out!',
            subject: 'Tavern Attacked'
          },
          files: [
            {
              uri: 'https://baconmockup.com/470/300/',
              fileName: 'hiding.jpg',
              contentType: 'image/jpeg',
              length: 156023
            },
            {
              uri: 'https://baconmockup.com/470/300/',
              fileName: 'hiding.jpg',
              contentType: 'image/jpeg',
              length: 156023
            },
            {
              uri: 'https://baconmockup.com/300/470/',
              fileName: 'hiding.jpg',
              contentType: 'image/jpeg',
              length: 156023
            }
          ],
          incidentId: 'dce4b6e6257c4f8eb7e0e3a407d85110',
          incident: {
            id: 'dce4b6e6257c4f8eb7e0e3a407d85110',
            name: 'Incident 1',
            priority: PriorityType.Emergency,
            type: IncidentSettings.TypeEnum.Generic
          },
          severityAssessment: {
            comment: 'This is a test, do not be alarmed!',
            responses: [
              {
                questionId: 'id_hilton_assessment_questions_seriousillness',
                question: 'Was there serious illness, injury, or loss of life?',
                optionId: 'id_hilton_assessment_responses_yesno_yes',
                option: 'Yes'
              },
              {
                questionId: 'id_hilton_assessment_questions_propertydamage',
                question: 'Was there significant damage or loss?',
                optionId: 'id_hilton_assessment_responses_yesno_yes',
                option: 'Yes'
              },
              {
                questionId: 'id_hilton_assessment_questions_businessdisruption',
                question: 'Was or do you expect there to be a significant business disruption?',
                optionId: 'id_hilton_assessment_responses_yesno_yes',
                option: 'Yes'
              },
              {
                questionId: 'id_hilton_assessment_questions_evacuation',
                question: 'Was there a partial or full evacuation of the property?',
                optionId: 'id_hilton_assessment_responses_yesno_yes',
                option: 'Yes'
              },
              {
                questionId: 'id_hilton_assessment_questions_mediainterest',
                question: 'Were there or do you anticipate media inquiries or external interest?',
                optionId: 'id_hilton_assessment_responses_yesno_yes',
                option: 'Yes'
              }
            ]
          },
          poll: {
            questionId: 1001,
            question: 'You okay?',
            options: [
              {
                optionId: 1002,
                selectionChoice: 1,
                value: 'Yes',
                description: 'Yes'
              },
              {
                optionId: 1003,
                selectionChoice: 2,
                value: 'No',
                description: 'No'
              }
            ]
          },
        },
        schedule: {
          scheduled: false
        },
        recipients: {
          uniqueContactCount: 3,
          groupIds: [1002, 1003, 1004], // Default groupIds imply MAGs (Mandatory Groups)
          mandatoryGroupIds: [],
          contactIds: [1001, 1002, 1003]
        },
        sender: {
          displayName: 'Taylor Grohs',
          email: 'basketballking@earthlink.com',
          externalId: 'RnD007',
          asset: {
            name: 'Boise Alert Sense'
          }
        }
      }, {
        // Non-Emergency Alert without Severity Assessment or Attachments
        id: 3,
        timeSent: new Date(1515009599000),
        location: {
          point: {
            lat: DEFAULT_COORDS.lat + 2,
            lng: DEFAULT_COORDS.lng + 2
          }
        },
        message: {
          incidentId: 'dce4b6e6257c4f8eb7e0e3a407d85110',

          incident: {
            id: 'dce4b6e6257c4f8eb7e0e3a407d85110',
            name: 'Incident 2',
            priority: PriorityType.Emergency,
            type: IncidentSettings.TypeEnum.Generic
          },
        },
        sender: {
          displayName: 'Taylor Grohs',
          email: 'basketballking@earthlink.com',
          externalId: 'RnD007',
          asset: {
            name: 'Boise Alert Sense'
          }
        }
      }
    ];
  }

  protected createGenerated(): AlertSettings[] {
    const list: AlertSettings[] = [];
    for (let i = 0; i < 100; i++) {
      if (i % 2 === 0) {
        list.push(this.generateMinimal(i));
      } else {
        list.push(this.generateAlternate(i));
      }
    }
    return list;
  }

  private generateMinimal(i: number): AlertSettings {
    return {
      id: 100 + i,
      alertType: AlertType.Default,
      timeSent: new Date(),
      location: {
        point: {
          lat: DEFAULT_COORDS.lat + i,
          lng: DEFAULT_COORDS.lng + i
        }
      },
      channels: {
        push: {
          send: true,
        }
      },
      formType: FormType.Quick,
      message: {
        priority: PriorityType.NonEmergency,
        basic: {
          message: 'Generated',
          subject: 'Generated'
        }
      },
      recipients: {
        contactIds: [1001]
      },
      sender: {
        displayName: 'Generated ' + i,
        email: 'generated@nagdom.com'
      }
    };
  }

  private generateAlternate(i: number): AlertSettings {
    const incident: IncidentSettings = genericIncidentData.generated[i];
    incident.type = IncidentSettings.TypeEnum.Generic;
    return {
      id: 100 + i,
      alertType: AlertType.Conference,
      location: {
        point: {
          lat: DEFAULT_COORDS.lat + i,
          lng: DEFAULT_COORDS.lng + i
        }
      },
      channels: {
        email: {
          send: true,
        },
        push: {
          send: true,
        },
        textMessage: {
          primary: true,
          secondary: false,
          deliveryMethod: TextMessageChannel.DeliveryMethodEnum.Sms,
          send: true
        },
        voice: {
          send: false
        }
      },
      formType: FormType.Quick,
      message: {
        priority: PriorityType.Emergency,
        basic: {
          message: 'Generated',
          subject: 'Generated'
        },
        incidentId: incident ? incident.id : null,
        incident: incident
      },
      schedule: {
        scheduled: false
      },
      recipients: {
        groupIds: [1002]
      },
      sender: {
        displayName: 'Generated ' + i,
        email: 'generated@nagdom.com',
        asset: {
          name: 'GeneratedAsset'
        }
      }
    };
  }

  createAlert(body: SendAlertRequest): any { // : SendAlertResponse {
    if (!body.settings.id) {
      body.settings.id = Math.floor(Math.random() * 1000000);
    }
    if (!body.settings.alertType) {
      body.settings.alertType = AlertType.Default;
    }

    // This data was manually added
    this._manual.push(body.settings);

    // The json for this doesn't match the casing in the swagger
    // let response: SendAlertResponse = {
    return {
      AlertId: body.settings.id,
      SentStatus: {
        AlertId: body.settings.id,
        AlertType: body.settings.alertType,
        AlertStatus: 'Queued',
        DateSent: new Date(),
        DateCompleted: new Date(),
        TimeZone: 'MT ',
        SenderName: body.settings.sender.displayName,
        SenderEmail: body.settings.sender.email,
        Subject: body.settings.message.basic.subject,
        Message: body.settings.message.basic.message
      },
      HasErrors: false,
      IsValid: true
    };
  }
}
export const alertSettingsData = AlertSettingsData.instance;
